import { GlobeSimpleIcon } from "@phosphor-icons/react/dist/ssr";
import logo from "apps/visits/core/assets/svg/logo.svg";
import clsx from "clsx";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/core/shared/v2/ui/dropdown-menu";

interface HeaderProps {
  onLogoClick?: () => void;
  contractorLogoUrl?: string;
}

export function Header({ onLogoClick, contractorLogoUrl }: HeaderProps) {
  const { i18n, t } = useTranslation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const i18nLanguages = useMemo(() => i18n.languages, [i18n.languages]);

  const changeLanguageHandler = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <header
      className={clsx([
        "nav-menu-top top-0 flex h-16 justify-center bg-[var(--header-background-color)]/60 px-4 md:h-24 md:px-12",
        "sticky left-0 z-50 mt-[calc(var(--snsr-margin-top))] transition-all duration-100 ease-linear",
      ])}
      style={{ backdropFilter: "blur(15px)", WebkitBackdropFilter: "blur(15px)" }}
    >
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-x-3">
        <div className="grid grid-cols-2 items-center gap-x-3">
          {onLogoClick ? (
            <button type="button" onClick={onLogoClick} className="cursor-pointer border-0 bg-transparent p-0">
              <img width="140" height="24" src={logo} alt="uPacjenta logo" />
            </button>
          ) : (
            <img width="140" height="24" src={logo} alt="uPacjenta logo" />
          )}
          {contractorLogoUrl && <img src={contractorLogoUrl} alt="partner logo" className="max-h-12" />}
        </div>
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger asChild>
            <button
              type="button"
              className={clsx([
                "bg-transparent text-foreground hover:bg-black/5",
                "flex h-10 cursor-pointer select-none items-center gap-1 text-nowrap rounded-full px-4 font-medium font-sans text-base outline-none transition-colors",
              ])}
            >
              <GlobeSimpleIcon className="text-lg" /> <span>{t(`LANGUAGES.${i18n.language?.toUpperCase()}`)}</span>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {i18nLanguages.map((lang) => (
              <DropdownMenuItem key={lang} onClick={() => changeLanguageHandler(lang)}>
                {t(`LANGUAGES.${lang.toUpperCase()}`)}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
